import styled from 'styled-components';
// import palette from '../../../lib/styles/palette';
import React, { useState } from 'react';
import DriveFormSingle from './DriveFormSingle';
import DriveFormDual from './DriveFormDual';
import { useDispatch } from 'react-redux';
import { changeBody } from '../../../modules/conveyor/conveyorWriteSlice';
import DriveFormTriple from './DriveFormTriple';
// import DriveForm from './DriveForm';

const DriveSelectionForm = ({ drives: prevDrives, resistance, input, output }) => {
    const dispatch = useDispatch();
    const [drives] = useState(prevDrives || []);
    const [driveType, setDriveType] = useState(
        prevDrives && Array.isArray(prevDrives) && prevDrives.length === 1
            ? 'single'
            : prevDrives && Array.isArray(prevDrives) && prevDrives.length === 2
            ? 'dual'
            : prevDrives && Array.isArray(prevDrives) && prevDrives.length === 3
            ? 'triple'
            : '',
    );

    const handleSelection = (e) => {
        dispatch(
            changeBody({
                key: 'pulleys',
                value: null,
            }),
        );
        setDriveType(e.target.value);
    };

    return (
        // <DriveSelectionFormBlock>
        //     <Table>
        //         <thead></thead>
        //         <tbody>
        //             <Select value={driveType} onChange={handleSelection}>
        //                 <option value="" disabled>
        //                     Select Drive(s) Q'ty
        //                 </option>
        //                 <option value="single" selected>
        //                     Single Drive
        //                 </option>
        //                 <option value="dual">Dual Drive</option>
        //                 <option value="triple">Triple Drive</option>
        //             </Select>
        //             <Spacer />
        //             {driveType === 'single' && (
        //                 <DriveFormSingle
        //                 // <DriveForm
        //                     drives={drives}
        //                     resistance={resistance}
        //                     input={input}
        //                     output={output}
        //                 />
        //             )}
        //             {driveType === 'dual' && (
        //                 <DriveFormDual
        //                     drives={drives}
        //                     resistance={resistance}
        //                     input={input}
        //                     output={output}
        //                 />
        //             )}
        //             {driveType === 'triple' && (
        //                 <DriveFormTriple
        //                     drives={drives}
        //                     resistance={resistance}
        //                     input={input}
        //                     output={output}
        //                 />
        //             )}
        //         </tbody>
        //     </Table>
        // </DriveSelectionFormBlock>
        <Wrapper>
            <Select value={driveType} onChange={handleSelection}>
                <option value="" disabled>
                    Select Drive(s) Q'ty
                </option>
                <option value="single" selected>
                    Single Drive
                </option>
                <option value="dual">Dual Drive</option>
                <option value="triple">Triple Drive</option>
            </Select>
            <Spacer />
            {driveType === 'single' && <DriveFormSingle drives={drives} resistance={resistance} input={input} output={output} />}
            {driveType === 'dual' && <DriveFormDual drives={drives} resistance={resistance} input={input} output={output} />}
            {driveType === 'triple' && <DriveFormTriple drives={drives} resistance={resistance} input={input} output={output} />}
        </Wrapper>
    );
};

export default DriveSelectionForm;

const Wrapper = styled.div``;

// const DriveSelectionFormBlock = styled.div`
//     // background-color: yellow;
//     width: 100%;
//     max-width: 1000px;
//     // margin: 0 auto;
//     margin-top: 2rem;
//     td {
//         padding: 0.125rem 0.5rem;
//         // border: 1px solid;
//     }
// `;

// const Table = styled.div`
//     width: 100%;
//     border-collapse: collapse;
//     .tr-hover-effect {
//         &:hover {
//             background-color: ${palette.gray[1]};
//             transition: 0.3s;
//         }
//     }
// `;

const Select = styled.select`
    border: none;
    outline: none;
    margin-left: -0.25rem;
    font-size: 1.17rem;
    font-weight: bold;
`;

const Spacer = styled.div`
    margin-bottom: 1rem;
`;
